import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
// 搜索列表页
export var searchM = function searchM(keyword) {
  return "//m.zhuanzhuan.com/open/ZZOpenBusiness/index.html?common=true&needHideHead=1&keyword=".concat(keyword, "&webview=zzn#/game-search");
};

// 授权接口地址
export var jsticket = function jsticket(wxPublicId, callbackName) {
  return "https://app.zhuanzhuan.com/zzopen/wxcommon/getJsTicket?wxPublicId=".concat(wxPublicId, "&url=").concat(encodeURIComponent(window.location.href.split('#')[0]), "&callback=").concat(callbackName);
};
var getWXmsgUrl = function getWXmsgUrl(url, enterpriseId) {
  return "https://wxmsg.zhuanspirit.com/api/getSignature?url=".concat(window.encodeURIComponent(url || window.location.href.split('#')[0]), "&enterpriseId=").concat(enterpriseId || 0);
};

//

//
export var wxWorkTicket = function wxWorkTicket() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = (opts === null || opts === void 0 ? void 0 : opts.callback) || function () {};
  var xhr = new XMLHttpRequest();
  xhr.open('GET', getWXmsgUrl(opts.url, opts.id), true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        var res = JSON.parse(xhr.responseText);
        callback(res.resp || {});
      }
    }
  };
  xhr.send();
};
export var QQ_MAP_KEY = 'ATQBZ-DRPRJ-PCMFD-FEOUW-OV3NK-J2BEG';
export var getPoiMarkerUrl = function getPoiMarkerUrl(params) {
  var _window$nativeAdapter;
  var key = ((_window$nativeAdapter = window.nativeAdapterConfig) === null || _window$nativeAdapter === void 0 ? void 0 : _window$nativeAdapter.qqMapKey) || QQ_MAP_KEY;
  return "https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:".concat(params.lat || 0, ",").concat(params.lon || 0, ";title:").concat(params.name || '', ";addr:").concat(params.address || '', "&init_view=").concat(params.scale || 28, "&key=").concat(key, "&referer=zzapp");
};